import { Injectable, Inject, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { environment } from '@envs/environment';

@Injectable({
  providedIn: 'root',
})
export class AppInitializationService {
  private renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private titleService: Title,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  initializeApp(): Promise<void> {
    return new Promise((resolve) => {
      // Set favicon if logo exists in localStorage
      const fav = localStorage.getItem('fav');
      if (fav) {
        this.changeFavicon(environment.api + fav);
      }

      // Set title if accountname exists in localStorage
      const accountName = localStorage.getItem('accountname');
      if (accountName) {
        this.titleService.setTitle(accountName);
      }

      resolve();
    });
  }

  private changeFavicon(iconPath: string): void {
    const head =
      this.document.head || this.document.getElementsByTagName('head')[0];
    const link: HTMLLinkElement = this.renderer.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = iconPath;

    // Remove existing favicon
    const existingFavicon = head.querySelector('link[rel="icon"]');
    if (existingFavicon) {
      this.renderer.removeChild(head, existingFavicon);
    }

    // Add new favicon
    this.renderer.appendChild(head, link);
  }
}
